import {
  CONDITION,
  DISADVANTAGE,
  ADVANTAGE,
  VULNERABLE,
  ATTACK_ROLL,
} from '../../character/content/templates';

export default function Conditions() {
  return (
    <>
      <p>{CONDITION}s are effects that grant specific benefits or drawbacks to the target they are attached to.</p>

      <h3 id="standard-conditions">STANDARD CONDITIONS</h3>
      <p>Daggerheart has three standard {CONDITION}s:</p>

      <h3 id="condition-hidden">HIDDEN</h3>
      <p>While you're out of sight from all enemies and they don't otherwise know your location, you gain the Hidden {CONDITION}. Any rolls against a Hidden creature have {DISADVANTAGE}. After an adversary moves to where they would see you, you move into their line of sight, or you make an {ATTACK_ROLL}, you are no longer Hidden.</p>

      <h3 id="condition-restrained">RESTRAINED</h3>
      <p>Restrained characters can't move, but you can still take actions from their current position.</p>

      <h3 id="condition-vulnerable">{VULNERABLE}</h3>
      <p>When a creature is {VULNERABLE}, all rolls targeting them have {ADVANTAGE}.</p>
      <p>Some features can apply special or unique {CONDITION}s, which work as described in the feature text.</p>
      <p>Unless otherwise noted, the same {CONDITION} can't be applied more than once to the same target.</p>

      <h3 id="temporary-tags">TEMPORARY TAGS &amp; SPECIAL {CONDITION}S</h3>
      <p>The <strong>temporary</strong> tag denotes a {CONDITION} or effect that the affected creature can clear by making a move against it. When an affected PC makes a move to clear a temporary {CONDITION} or effect, it normally requires a successful action roll using an appropriate trait. When an affected adversary makes a move to clear a temporary {CONDITION} or effect, the GM puts the spotlight on the adversary and describes how they do it; this doesn't require a roll but it does use up that adversary's spotlight.</p>
      <p><strong>Special {CONDITION}s</strong> are only cleared when specific requirements are met, such as completing a certain action or using a particular item. The requirements for clearing these {CONDITION}s are stated in the text of the effect that applies the {CONDITION}.</p>
    </>
  );
}
